var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 13.4993V12.8327C21.8333 11.8993 21.8333 11.4326 21.6517 11.076C21.4919 10.7624 21.2369 10.5075 20.9233 10.3477C20.5668 10.166 20.1001 10.166 19.1667 10.166H17.8333C16.8999 10.166 16.4332 10.166 16.0767 10.3477C15.7631 10.5075 15.5081 10.7624 15.3483 11.076C15.1667 11.4326 15.1667 11.8993 15.1667 12.8327V13.4993M16.8333 18.0827V22.2493M20.1667 18.0827V22.2493M11 13.4993H26M24.3333 13.4993V22.8327C24.3333 24.2328 24.3333 24.9329 24.0608 25.4677C23.8212 25.9381 23.4387 26.3205 22.9683 26.5602C22.4335 26.8327 21.7335 26.8327 20.3333 26.8327H16.6667C15.2665 26.8327 14.5665 26.8327 14.0317 26.5602C13.5613 26.3205 13.1788 25.9381 12.9392 25.4677C12.6667 24.9329 12.6667 24.2328 12.6667 22.8327V13.4993",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashicon);
export default __webpack_public_path__ + "static/media/trashicon.817b70715819a863968a266ead1326af.svg";
export { ForwardRef as ReactComponent };